/**
 * avatars/items/held-items.js
 * Xây dựng hình học 3D cho createHeldItem - Dispatcher Registry
 */

import * as THREE from 'three';
import { HELD_ITEMS_REGISTRY } from './held/index.js';

export function createHeldItem(lib, type) {
  const itemGroup = new THREE.Group();
  itemGroup.name = `Held_${type}`;

  const builder = HELD_ITEMS_REGISTRY[type];
  if (builder) {
    builder(lib, itemGroup);
  }

  return itemGroup;
}
